import {
  Plus,
  Grid3X3,
  Heart,
  Search,
  Home,
  UserRound,
  Compass,
  Menu,
} from "lucide-react";
import StatusBadge from "./StatusBadge";
export function formatDate(date) {
  return new Date(date)
    .toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "short",
      timeZone: "UTC",
    })
    .replace(" ", "-");
}
export default function CreativeGrid({ records, layout, onSelect, user }) {
  const instagram = layout === "instagram";
  const grid = (
    <div className={instagram ? "instagram-grid" : "calendar-grid"}>
      {records.map((record) => (
        <button
          className={`creative-card ${record.creativeUrl ? "" : "empty-card"}`}
          key={record._id}
          onClick={() => onSelect(record)}
          aria-label={`${record.creativeUrl ? "Review" : "Add creative for"} ${formatDate(record.date)}`}
        >
          <div className="card-image">
            {record.creativeUrl ? (
              <img
                src={record.creativeUrl}
                alt={record.caption}
                loading="lazy"
              />
            ) : (
              <div className="empty-content">
                <span>
                  <Plus size={20} strokeWidth={1.3} />
                </span>
                {!instagram && (
                  <>
                    <strong>A little room for an idea</strong>
                    <small>Add a creative</small>
                  </>
                )}
              </div>
            )}
            <span className="date-label">{formatDate(record.date)}</span>
            {instagram && record.creativeUrl && (
              <span
                className={`grid-status ${record.status.toLowerCase().replaceAll(" ", "-")}`}
                aria-label={record.status}
              />
            )}
          </div>
          {!instagram && (
            <div className="card-footer">
              {record.creativeUrl ? (
                <>
                  <StatusBadge status={record.status} />
                  <span className="card-type">Post</span>
                </>
              ) : (
                <span className="unplanned">
                  <span />
                  Not planned yet
                </span>
              )}
            </div>
          )}
        </button>
      ))}
    </div>
  );
  if (!instagram) return grid;
  return (
    <div className="instagram-wrap">
      <div className="instagram-explainer">
        <span className="eyebrow">THE BIG PICTURE</span>
        <h2>
          See your story
          <br />
          come together.
        </h2>
        <p>
          A fresh perspective on your feed.
          <br />
          The same ideas, a different point of view.
        </p>
        <span className="preview-label">
          <span className="live-dot" /> Live feed preview
        </span>
      </div>
      <section className="phone-preview" aria-label="Instagram Grid preview">
        <div className="phone-top">
          <strong>forma.studio</strong>
          <Menu size={19} />
        </div>
        <div className="phone-search">
          <Search size={15} />
          <span>Explore your creative feed</span>
        </div>
        <div className="phone-profile">
          <span className="profile-logo">f.</span>
          <div>
            <strong>{user.name}'s studio</strong>
            <p>Thoughtful ideas. Everyday inspiration.</p>
            <small>
              {records.filter((r) => r.creativeUrl).length} creatives · A life
              well created
            </small>
          </div>
        </div>
        <div className="phone-grid-heading">
          <Grid3X3 size={16} /> YOUR CREATIVE GRID
        </div>
        {grid}
        <div
          className="phone-bottom"
          aria-label="Decorative social preview navigation"
        >
          <Home />
          <Compass />
          <Plus />
          <Heart />
          <UserRound />
        </div>
      </section>
    </div>
  );
}
